export { EditProductGroupSalePriceModal } from './ui/EditProductGroupSalePriceModal.main';
export type { EditProductGroupSalePriceModalProps } from './ui/EditProductGroupSalePriceModal.main';
